import groq from 'groq';
import sanityClient from 'utilities/sanityClient';
export function fetchSanityConceptPage(conceptPageSlug, regionId) {
    const query = groq `
*[ _type == 'conceptPage' && slug.current == $conceptPageSlug ][0] {
    title,
    mainImage,
    "featuredProductIds": regionProducts.region_${regionId},
    body,
    bannerStrip1,
    bannerStrip2,
    "elements": pageBuilder[] {
        "type": _type,
        _type == "abTest" => @-> {
            "name": title,
            variantA->{ "type": _type, "elementId":_id },
            variantB->{ "type": _type, "elementId":_id }
        },
        _type == "reference" => @-> {
            "type": _type,
            _type != "ctaButton" => {
                "elementId": _id
            },
            _type == "ctaButton" => {
                title,
                target
            }
        },
        _type != "reference" && _type != "abTest" => @ {
            "type": content,
        }
    }
}
    `;
    const minimizedQuery = query.replace(/[\s\n]+/g, '');
    return sanityClient.fetch(minimizedQuery, { conceptPageSlug });
}
